import React from "react";
import { Spinner } from "react-bootstrap";
import { defaultImageCar } from "../../utils/defaultValue";
import { PrimaryButton } from "../PrimaryButton/PrimaryButton";
import { useHistory } from "react-router-dom";

// onContinue (opsional): tampilkan tombol "Lanjut Lelang" untuk langsung pindah ke lot berikutnya.
const ResultLelang = ({ status, dataAuction, isRegular = false, onContinue }) => {
  const { push } = useHistory();
  return (
    <>
      {" "}
      <div className="com-modal-bg"></div>
      <div className="com-modal d-flex flex-center">
        <div className="com-modal-dialog">
          <div className="com-modal-content">
            <div className="winner-auction">
              {status === "LOADING" ? (
                <>
                  <div className="winner-auction-body text-center">
                    <div className="py-4 mb-3">
                      <Spinner animation="grow" />
                    </div>
                    <div>
                      {!isRegular
                        ? "Sedang memilih pemenang, silahkan refresh halaman ini secara berkala"
                        : "Mohon tunggu, kami sedang memilih pemenangnya..."}
                    </div>
                    {!isRegular && (
                      <PrimaryButton style={{ marginTop: "10px" }} onClick={() => push("/")}>
                        Kembali ke Halaman Utama
                      </PrimaryButton>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="text-center pt-3 fs-5 fw-bold">Lot telah berakhir</div>
                  <div className="mx-4 mt-2 text-center">
                    <PrimaryButton style={{ marginRight: "10px" }} onClick={() => push("/")}>
                      Home
                    </PrimaryButton>
                    <PrimaryButton onClick={() => push("/unit-lelang")}>Unit Lelang</PrimaryButton>
                  </div>
                  <div className="winner-auction-body">
                    <div className="auction-unit mb-3">
                      <div
                        className="auction-unit-image m-2 "
                        style={{
                          background: `url("${dataAuction?.pictures?.length > 0 ? dataAuction?.pictures[0]?.image_url : defaultImageCar}")`,
                          height: "90px",
                          width: "120px",
                          borderRadius: "12px",
                        }}
                      ></div>
                      <div className="auction-unit-content">
                        <div className="auction-unit-info w-100 d-flex flex-column h-100">
                          <div className="mb-2 text-black fw-bold ">{dataAuction?.unit_name}</div>
                          <div>
                            <div className={`badge d-inline ${status === "TERJUAL" ? "bg-primary" : "bg-secondary"}`}>
                              {status}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-center">Anda akan segera diarahkan pada lot selanjutnya...</div>
                    {onContinue ? (
                      <div className="text-center mt-3">
                        <PrimaryButton onClick={onContinue}>Lanjut Lelang</PrimaryButton>
                      </div>
                    ) : null}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResultLelang;
